import { render, staticRenderFns } from "./my_accountJM.vue?vue&type=template&id=5299c93c&scoped=true&"
import script from "./my_accountJM.vue?vue&type=script&lang=js&"
export * from "./my_accountJM.vue?vue&type=script&lang=js&"
import style0 from "./my_accountJM.vue?vue&type=style&index=0&id=5299c93c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5299c93c",
  null
  
)

export default component.exports